import { render, staticRenderFns } from "./SizeEditor.vue?vue&type=template&id=02de6f41&scoped=true&"
import script from "./SizeEditor.vue?vue&type=script&lang=ts&"
export * from "./SizeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SizeEditor.vue?vue&type=style&index=0&id=02de6f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de6f41",
  null
  
)

export default component.exports